import React from 'react';
import { Loader2 } from 'lucide-react';
import styles from './ui-button.module.scss';

type ButtonVariant = 'primary' | 'dark' | 'outline' | 'outline-primary' | 'ghost' | 'link';
type ButtonSize = 'xs' | 'sm' | 'md' | 'lg';

interface UIButtonProps {
    variant?: ButtonVariant;
    size?: ButtonSize;
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    label?: string;
    disabled?: boolean;
    loading?: boolean;
    icon?: React.ReactNode;
    iconRight?: React.ReactNode;
    iconOnly?: boolean;
    type?: 'button' | 'submit' | 'reset';
    className?: string;
    children?: React.ReactNode;
    block?: boolean;
}

export function UIButton({
    variant = 'primary',
    size = 'md',
    onClick,
    label,
    disabled = false,
    loading = false,
    icon,
    iconRight,
    iconOnly = false,
    type = 'button',
    className = '',
    children,
    block = false,
}: UIButtonProps) {
    const classes = [
        styles.button,
        styles[`variant-${variant}`],
        styles[`size-${size}`],
        block ? styles.block : '',
        iconOnly ? styles.iconOnly : '',
        loading ? styles.loading : '',
        className,
    ].filter(Boolean).join(' ');

    return (
        <button
            type={type}
            className={classes}
            onClick={onClick}
            disabled={disabled || loading}
        >
            {loading && (
                <span className={styles.spinner}>
                    <Loader2 size={size === 'xs' ? 12 : size === 'sm' ? 14 : size === 'lg' ? 20 : 16} />
                </span>
            )}
            {!loading && icon && <span className={styles.icon}>{icon}</span>}
            {!iconOnly && (label || children) && (
                <span className={styles.label}>{children || label}</span>
            )}
            {!loading && iconRight && <span className={styles.icon}>{iconRight}</span>}
        </button>
    );
}

export default UIButton;
